import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link as RouterLink } from 'react-router-dom';

import {
  makeStyles,
  Grid,
  Typography,
  Container,
  Link,
} from '@material-ui/core';


const useStyles = makeStyles({
  wrapper: {
    height: '100%'
  }
});

const NotFound = (props) => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <Container maxWidth="sm" component="main" className={classes.wrapper}>
      <Grid
        container
        justify="center"
        alignItems="center"
        className={classes.wrapper}
      >
        <Grid item container direction="column">
          <Typography variant="h2" component="span">404</Typography>
          <Typography variant="h4" component="h1" gutterBottom>{t('pageNotFound')}</Typography>
          <Link component={RouterLink} to="/">{t('backHome')}</Link>
        </Grid>
      </Grid>
    </Container>
  );
};

export default NotFound;
